<template>
  <div class="LKNotificationPagesView">
    <LKProgressCircular
      v-if="isLoadingAsyncData"
      overlay
      :size="50"
      style="align-items: start; padding-top: 30vh;"
    />
    <template v-else-if="isReady">
      <div
        class="LKNotificationPagesView__content is-title"
        v-text="title"
      />
      <div class="LKNotificationPagesView__divider" />
      <div class="LKNotificationPagesView__content" v-html="body" />
    </template>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import {
  lkNotificationPagesMapper as StoreMapper,
} from './store'

export default {
  name: 'LKNotificationPagesView',
  components: { LKProgressCircular },
  data: () => ({
    isLoadingAsyncData: false,
    data: {},
  }),
  computed: {
    title() {
      return this.data?.title || ''
    },
    body() {
      return this.data?.body || ''
    },
    isReady() {
      return !isEmpty(this.data)
    },
  },
  created() {
    this.getPage()
  },
  methods: {
    ...StoreMapper.mapActions(['getOneByUrl']),
    async getPage() {
      this.isLoadingAsyncData = true
      this.data = {}
      try {
        const { url } = this.$route.params
        this.data = await this.getOneByUrl({ url })
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoadingAsyncData = false
    },
  },
}
</script>

<style lang="scss">
.LKNotificationPagesView {
  background-color: $color-white;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba($color-black, 0.06);

  &__content {
    padding: 23px 30px;
    font-size: 16px;

    &.is-title {
      font-size: 24px;
      font-weight: 700;
      line-height: 1.2;
    }
  }

  &__divider {
    box-sizing: content-box;
    margin: 0 30px;
    border-bottom: 1px solid $webflow-color-blue-hover;
    opacity: 0.5;
  }
}
</style>
